($ => {
  function customTooltips() {
    const product = CPB.getStore().getState().Product
    let tippyInstances = []
    
    update()
    document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', () => {
      setTimeout(update)
    })
    document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', () => {
      setTimeout(update)
    })    
    
    function update() {
      const categories = $('.cpb-category-img.custom-tooltips--js')
      if(categories.length === 0) destroyAllInstances()
      else if(categories.filter('[data-custom-tippy-processed="true"]').length === 0) destroyAllInstances()
      else hideAllInstances()
      
      categories.each(function() {
        const category = $(this)
        if(category.attr('data-custom-tippy-processed') === 'true') return
        category.attr('data-custom-tippy-processed', true)
        let categoryObj
        product.panels.find(panel => {
          categoryObj = panel.categories.find(categoryObj => categoryObj.id === category.attr('data-category-id'))
          return !!categoryObj
        })

        category.find('.cpb-option-type-img').each(function() {
          const option = $(this)
          const optionObj = categoryObj.options.find(optionObj => optionObj.id === option.attr('data-option-id'))
          createTippyInstance(this, optionObj.option.data.label, optionObj.option.data.value)
        })
      })
    }
    function createTippyInstance(element, title, image) {
      const content = `<div class="cpb-custom-tooltip">
        <img src="${image}" alt=""/>
        <div class="cpb-custom-tooltip__title">${title}</div>
      </div>`
      tippyInstances.push(tippy(element, {
        allowHTML: true,
        content,
        placement: 'bottom'
      }))      
    }
    function destroyAllInstances() {
      tippyInstances.forEach(instance => {
        instance.destroy()
      })
      tippyInstances = []
    }
    function hideAllInstances() {
      tippyInstances.forEach(instance => {
        instance.hide()
      })
    }
  }

  const changeBtnsTextContent = () => {
    const prevTabBtn = document.querySelector('#product-builder .cpb-prev-tab-button');
    const nextTabBtn = document.querySelector('#product-builder .cpb-next-tab-button:not(.cpb-prev-tab-button)');
    prevTabBtn.textContent = "Previous Step";
    nextTabBtn.textContent = "Next Step";
  }

  const showAddToCartOnlyOnLastStep = () => {
    const addToCartBtn = document.querySelector('#product-builder .cpb-add-to-cart-button');
    const lastPanel = document.querySelector('#product-builder .cpb-panels-tabs .cpb-product-panel:last-child');
    
    addToCartBtn.classList.add('cpb-hide');

    const mutationHandler = () => {
      if (lastPanel.classList.contains('react-tabs__tab-panel--selected')) {
        addToCartBtn.classList.remove('cpb-hide');
      } else {
        addToCartBtn.classList.add('cpb-hide');
      }
    }
    
    new MutationObserver(mutationHandler).observe(lastPanel, { attributes: true });
  }

  const collapsibleTabs = () => {
    const collapsibleTabsElement = document.querySelector('#cpb-collapsible-tabs');
    const panelsContainer = document.querySelector('.cpb-panels-container');

    collapsibleTabsElement.querySelectorAll('.collapsible-tabs__tab').forEach(tab => {
      const title = tab.querySelector('.collapsible-tabs__tab-title');
      title.addEventListener('click', () => {
        tab.classList.toggle('is-open');
      });
    });

    // collapsibleTabsElement.style = '';
    panelsContainer.append(collapsibleTabsElement);
  }

  const initPopups = () => {
    const tabChangeHendler = () => {
      const links = document.querySelectorAll('a[href*="/size-chart"],a[href*="/fit-guide"]');
      console.log(links);
      if (links.length == 0) return
      links.forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const url = e.currentTarget.href;
          fetch(url)
            .then(res => res.text())
            .then(page => {
              const iframe = document.createElement('iframe');
              iframe.classList.add('cpb-custom-popup');
              iframe.style = `width: 100%;border: none;height: 90vh;`;

              const doc = document.createElement('div');
              doc.innerHTML = page;
              const main = doc.querySelector('main');
              main.style = `position: fixed;top: 0;background: white;z-index: 999999;width: 100%;height: 100%;overflow: scroll;`
          
              iframe.srcdoc = doc.outerHTML;
              Swal.fire({
                html: iframe,
                width: innerWidth > 1400 ? '60%' : '90%',
                showCloseButton: true,
                showConfirmButton: false
              });
            });
        })
      });
    };

    document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', tabChangeHendler);
  }
  
  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', () => {
    customTooltips();
    changeBtnsTextContent();
    showAddToCartOnlyOnLastStep();
    collapsibleTabs();
    initPopups();
  })
})(jQuery)